enum Borough {
  BRONX = 'Bronx',
  BROOKLYN = 'Brooklyn',
  MANHATTAN = 'Manhattan',
  QUEENS = 'Queens',
  STATEN_ISLAND = 'Staten Island',
}

export default Borough
